import { createSlice } from '@reduxjs/toolkit';

const DoctorSlice = createSlice({
    name: 'doctorOutputSlice',
    initialState:{
        formCompleted: false,
        docotorCard: {
            doc: '',
            data:{
                archive: '',
                sign:{},
                table: {},
                color: '',
                description: '',
                conclusion: '',
                level: ''
            }
        }
    },
    reducers: {
        CISHCreation: (state,action) =>{
            state.formCompleted = true
            state.docotorCard = action.payload.credential
        },
        ExpressCreation: (state,action) =>{
            state.formCompleted = true
            state.docotorCard = action.payload.credential
        },
        GistologyCreation: (state,action) =>{
            state.formCompleted = true
            state.docotorCard = action.payload.credential
        },
        IGHCreation: (state,action) =>{
            state.formCompleted = true
            state.docotorCard = action.payload.credential
        },
        CardClean: (state, action) =>{
            state.formCompleted = false
            state.docotorCard = {
                doc: '',
                data:{
                    archive: '',
                    sign:{},
                    table: {},
                    color: '',
                    description: '',
                    conclusion: '',
                    level: ''
                }
            }
        }
    }
})

export const {CISHCreation, IGHCreation, GistologyCreation, ExpressCreation, CardClean} = DoctorSlice.actions;
export default DoctorSlice;